import React from 'react'
import axios from 'axios'
import { ClientModal } from '../models/ClientModal'
import { IClientFormValues } from '../containers/CreateClientForm'

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:2806/'
export const GET_CLIENT_URL = `${API_URL}api/v1/auth/admin/client/`
export const SEARCH_CLIENT_URL = `${API_URL}api/v1/auth/admin/client/`
export const CREATE_CLIENT_URL = `${API_URL}api/v1/auth/admin/client/`
export const EDIT_CLIENT_URL = `${API_URL}api/v1/auth/admin/client`
export const DELETE_CLIENT_URL = `${API_URL}api/v1/auth/admin/client/`
export const CHANGE_STATUS_CLIENT_URL = `${API_URL}api/v1/auth/admin/client/`
export const EXPORT_CLIENT_URL = `${API_URL}api/v1/auth/admin/client/export`
export const BULK_UPLOAD_CLIENT_URL = `${API_URL}api/v1/auth/admin/client/bulk-upload`


// Get Client Data
export async function getClientData(startIndex: number, limitNumber: number) {
  try {
    let clientData = await axios.post(`${GET_CLIENT_URL}${startIndex}/${limitNumber}`)
    return clientData
  } catch (e) {
    throw e
  }
}

// Search Client Data
export async function getSearchClientData(
  startIndex: number,
  limitNumber: number,
  searchText: string
) {
  try {
    let clientData = await axios.post(`${SEARCH_CLIENT_URL}${startIndex}/${limitNumber}`, {
      searchText,
    })
    return clientData
  } catch (e) {
    throw e
  }
}

// Create Client Data
export async function createClientData(clientObject: IClientFormValues) {
  try {
    let createClientData = await axios.post(`${CREATE_CLIENT_URL}`, {
      ...clientObject,
    })
    return createClientData
  } catch (e) {
    throw e
  }
}

// Delete Client Data
export async function deleteClientData(clientId: string) {
  try {
    let deleteClientData = await axios.delete(`${DELETE_CLIENT_URL}${clientId}`)
    return deleteClientData
  } catch (e) {
    throw e
  }
}

// Change Status Client Data
export async function changeStatusClientData(id: string, is_broker: boolean) {
  try {
    let clientData = await axios.put(`${CHANGE_STATUS_CLIENT_URL}`, {
      id,
      is_broker,
    })
    return clientData
  } catch (e) {
    throw e
  }
}

// Edit Client Data
export async function editClientData(clientObject: IClientFormValues, clientId: string) {
  try {
    let editClientData = await axios.put(`${EDIT_CLIENT_URL}`, {
      ...clientObject,
      clientId,
    })
    return editClientData
  } catch (e) {
    throw e
  }
}

// Export Client Data
export async function exportClientData(exportType: string) {
  try {
    let response = await axios.post(EXPORT_CLIENT_URL, { exportType, type: exportType })
    return response
  } catch (e) {
    throw e
  }
}

// Bulk Upload Client Data
export async function bulkUploadClientData(file: File | string) {
  try {
    let data: any
    let headers: any = {}
    if (file instanceof File) {
      const formData = new FormData()
      formData.append('file', file)
      data = formData
      headers['Content-Type'] = 'multipart/form-data'
    } else {
      data = { file_name: file, file }
    }
    let response = await axios.post(BULK_UPLOAD_CLIENT_URL, data, { headers })
    return response
  } catch (e) {
    throw e
  }
}


